import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
interface AudienceCardProps {
  emoji: string;
  title: string;
  description: string;
  index: number;
}
function AudienceCard({
  emoji,
  title,
  description,
  index
}: AudienceCardProps) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-50px'
  });
  return <motion.div ref={ref} className="p-8 rounded-3xl bg-white border border-rose-100 shadow-lg hover:shadow-xl transition-all duration-300" initial={{
    opacity: 0,
    y: 40
  }} animate={isInView ? {
    opacity: 1,
    y: 0
  } : {}} transition={{
    duration: 0.5,
    delay: index * 0.15
  }} whileHover={{
    y: -5
  }} data-id="element-194">
      <div className="w-16 h-16 bg-gradient-to-br from-rose-100 to-pink-100 rounded-2xl flex items-center justify-center text-4xl mb-5" data-id="element-195">
        {emoji}
      </div>
      <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-196">{title}</h3>
      <p className="text-slate-600 leading-relaxed" data-id="element-197">{description}</p>
    </motion.div>;
}
export function TargetAudience() {
  const audiences = [{
    emoji: '🏠',
    title: 'Mamás emprendedoras',
    description: 'Genera ingresos desde casa a tu propio ritmo, sin horarios fijos ni jefas.'
  }, {
    emoji: '🎨',
    title: 'Diseñadoras y creativas',
    description: 'Amplía tu catálogo con miles de diseños base y monetiza tu talento creativo.'
  }, {
    emoji: '🚀',
    title: 'Emprendedoras digitales',
    description: 'Lanza tu negocio online de imprimibles sin inventario y con ganancias reales.'
  }];
  const headerRef = useRef(null);
  const isHeaderInView = useInView(headerRef, {
    once: true
  });
  return <section className="w-full bg-gradient-to-b from-white to-pink-50 py-20 sm:py-28" data-id="element-198">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-199">
        {/* Header */}
        <motion.div ref={headerRef} className="text-center mb-16" initial={{
        opacity: 0,
        y: 30
      }} animate={isHeaderInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} data-id="element-200">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-slate-900 mb-4" data-id="element-201">
            👩‍💻 ¿Para quién es?
          </h2>
          <p className="text-xl sm:text-2xl font-bold text-rose-500 mb-4" data-id="element-202">
            Hecho Para Ti ✨
          </p>
          <p className="text-slate-600 max-w-2xl mx-auto" data-id="element-203">
            No importa si eres principiante o ya tienes experiencia. Este kit se
            adapta a tu ritmo y tus metas.
          </p>
        </motion.div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8" data-id="element-204">
          {audiences.map((audience, index) => <AudienceCard key={audience.title} emoji={audience.emoji} title={audience.title} description={audience.description} index={index} data-id="element-205" />)}
        </div>
      </div>
    </section>;
}